import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";
import { SOFTWARES_FOR_SELECT_PATH } from "./key";

export const getSoftwaresForSelect = async (
  searchText: string,
  page: number,
) => {
  const res = await apiClient.GET(SOFTWARES_FOR_SELECT_PATH, {
    params: { query: { freeText: searchText, page } },
  });
  return getDataOrThrowApiError(res);
};
